export const DATA_RECORD_ANNOTATION_TYPE = "dataRecord";

export const RECORD_DISCUSSION_CHUNK_SIZE = 50;

export const buildRecordDiscussionKey = (recordType, recordId) => `${recordType}:${recordId}`;

export const emptyRecordDiscussionSummary = {
    commentsCount: 0,
    commentsPreview: [],
    hasMoreComments: false,
    annotationsCount: 0,
    unresolvedAnnotationsCount: 0,
    highPriorityOpenCount: 0,
    closedAnnotationsCount: 0,
    annotationsPreview: [],
    hasMoreAnnotations: false,
};

export const chunkRecordIds = (recordIds, size = RECORD_DISCUSSION_CHUNK_SIZE) => {
    const chunks = [];
    for (let index = 0; index < recordIds.length; index += size) {
        chunks.push(recordIds.slice(index, index + size));
    }
    return chunks;
};
